export const ACCESS_TOKEN = 'ACCESS-TOKEN'; // 用户token
export const CURRENT_USER = 'CURRENT-USER'; // 当前用户信息
export const IS_SCREENLOCKED = 'IS-SCREENLOCKED'; // 是否锁屏
export const TABS_ROUTES = 'TABS-ROUTES'; // 标签页
